import type { Category } from '@mas-flow/types';
import { ApiHttpError } from './client';

async function jsonFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, { credentials: 'include', ...init });
  if (!res.ok) {
    const payload = await res.json().catch(() => undefined);
    throw new ApiHttpError(res.status, payload as { error: string; detail?: string } | undefined);
  }
  return (await res.json()) as T;
}

export async function list(): Promise<Category[]> {
  const { categories } = await jsonFetch<{ categories: Category[] }>('/api/categories');
  return categories;
}

export async function create(body: { name: string; color: string }): Promise<Category> {
  const { category } = await jsonFetch<{ category: Category }>('/api/categories', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return category;
}

export async function patch(
  id: string,
  body: { name?: string; color?: string; archived?: boolean },
  ifMatch: string,
): Promise<Category> {
  const { category } = await jsonFetch<{ category: Category }>(`/api/categories/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', 'If-Match': ifMatch },
    body: JSON.stringify(body),
  });
  return category;
}
